import { render, staticRenderFns } from "./GlobalLatestPostsCard.vue?vue&type=template&id=521fa36a"
import script from "./GlobalLatestPostsCard.vue?vue&type=script&lang=ts"
export * from "./GlobalLatestPostsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports